import { GraphQLClient, ClientError } from 'graphql-request';
import { environment } from 'environment';
import { setHasAccess, setIsLoggedIn } from 'shared/store/appStore';
import { getAuthToken } from 'shared/hooks/initApp/functions/getAuthToken';

const state = (process.env.REACT_APP_ENV || 'production') as keyof typeof environment;
const client = new GraphQLClient(environment[state].api);

const redirectToLogin = () => {
  setHasAccess(false);
  setIsLoggedIn(false);
};

/** True when the request failed due to auth (401, CORS-blocked 401, or non-JSON 401 body). */
const isAuthFailure = (err: unknown): boolean => {
  const status = (err as ClientError)?.response?.status;
  if (status === 401) return true;
  if (status !== undefined) return false;
  return (
    err instanceof TypeError ||
    (err as Error)?.message?.includes?.('Network request failed') ||
    err instanceof SyntaxError
  );
};

export const gqlClient = async (gql: string, variables: Record<string, unknown> = {}) => {
  let token: string | null = null;
  try {
    token = await getAuthToken();
  } catch {
    redirectToLogin();
    throw new Error('Session expired');
  }

  if (!token) {
    redirectToLogin();
    throw new Error('Session expired');
  }

  try {
    return await client.request(gql, variables, {
      Authorization: encodeURIComponent(token),
    });
  } catch (err) {
    if (isAuthFailure(err)) redirectToLogin();
    throw err;
  }
};
